import { Field, FieldArray } from "formik";
import React, { useState } from "react";
import { useDeepEffect } from "../../../abstracts";
import {
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  toMultiSelectValueById,
  required,
  usDateFormat,
} from "../../../utils";
import {
  FieldButtonGroup,
  MultiSelectDropdown,
  FieldDropSide,
  DatePicker,
} from "../../../components";
import { Row, Col } from "react-bootstrap";
import { getEmployeeClassification } from "../../../services";
import { get } from "lodash";
export const ExcludedEmployeeClassficationFields = (props) => {
  const { fields, values, setFieldValue, isEdit, isSave, planId } = props;
  const [
    excludedEmployeeClassifications,
    setExcludedEmployeeClassifications,
  ] = useState([]);
  const [excludedEmploymentStatuses, setExcludedEmploymentStatuses] = useState(
    []
  );
  useDeepEffect(() => {
    getEmployeeClassification(planId).then((response) => {
      setExcludedEmployeeClassifications(
        response.employeeClassifications &&
          response.employeeClassifications.map((val, ind) => ({
            label: val.codeName + val.code,
            value: val.code,
          }))
      );
      setExcludedEmploymentStatuses(
        response.employmentStatuses &&
          response.employmentStatuses.map((val, ind) => ({
            label: val.employmentStatusName + val.employmentStatusCode,
            value: val.employmentStatusCode,
          }))
      );
    });
  }, []);

  const selectedexcludedEmploymentStatuses = get(
    values.autoEnrollment,
    fields.excludedEmploymentStatuses
  );
  const selectedExcludedEmployeeClassifications = get(
    values.autoEnrollment,
    fields.excludedEmployeeClassifications
  );
  const { ...rest } = values;
  const onDaySelected = (fieldName, value) => {
    setFieldValue(fieldName, value);
  };
  const onExclusionTypeChange = (value) => {
    if (value !== get(values.autoEnrollment, fields.exclusionType)) {
      value !== 2 &&
        setFieldValue(
          `autoEnrollment.${fields.excludedEmployeeClassifications}`,
          null
        );
      value !== 3 &&
        setFieldValue(
          `autoEnrollment.${fields.excludedEmployeeClassifications}`,
          null
        );
      setFieldValue(`autoEnrollment.${fields.dateOfHire}`, null);
      setFieldValue(
        `autoEnrollment.${fields.hiredOnOrAfterDateEnrollment}`,
        null
      );
      setFieldValue(
        `autoEnrollment.${fields.hiredOnOrBeforeDateEnrollment}`,
        null
      );
      setFieldValue(`autoEnrollment.${fields.hiredBetweenFrom}`, null);
      setFieldValue(`autoEnrollment.${fields.hiredBetweenTo}`, null);
      value !== 1 && setFieldValue(`autoEnrollment.${fields.dateOfHire}`, null);
      setFieldValue(
        `autoEnrollment.${fields.hiredOnOrAfterDateEnrollment}`,
        null
      );
      setFieldValue(
        `autoEnrollment.${fields.hiredOnOrBeforeDateEnrollment}`,
        null
      );
      setFieldValue(`autoEnrollment.${fields.hiredBetweenFrom}`, null);
      setFieldValue(`autoEnrollment.${fields.hiredBetweenTo}`, null);
    }
  };

  const onDateOfHireChange = (value) => {
    if (value !== get(values.autoEnrollment, fields.dateOfHire)) {
      value !== 1 &&
        setFieldValue(
          `autoEnrollment.${fields.hiredOnOrAfterDateEnrollment}`,
          null
        );
      value !== 2 &&
        setFieldValue(
          `autoEnrollment.${fields.hiredOnOrBeforeDateEnrollment}`,
          null
        );
      value !== 3 &&
        setFieldValue(`autoEnrollment.${fields.hiredBetweenFrom}`, null);
      setFieldValue(`autoEnrollment.${fields.hiredBetweenTo}`, null);
    }
  };

  return (
    <div>
      <Field
        size="smd"
        isRequired
        name={`autoEnrollment.${fields.exclusionType}`}
        label={"Exclusion Type"}
        options={toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.EXCUSION_TYPE)}
        selectedValue={get(values.autoEnrollment, fields.exclusionType)}
        value={get(values.autoEnrollment, fields.exclusionType)}
        onChange={(value) => {
          setFieldValue(`autoEnrollment.${fields.exclusionType}`, value);
          onExclusionTypeChange(value);
        }}
        component={FieldButtonGroup}
        //validate={required}
        disabled={isEdit && !isSave}
      />

      {get(values.autoEnrollment, fields.exclusionType) === 2 ? (
        <>
          <Field
            size="md"
            isRequired
            label="Excluded Employee Classifications"
            options={excludedEmployeeClassifications}
            name={`autoEnrollment.${fields.excludedEmployeeClassifications}`}
            value={toMultiSelectValueById(
              selectedExcludedEmployeeClassifications,
              excludedEmployeeClassifications
            )}
            disabled={isEdit && !isSave}
            isMultiSelect
            popupContent={
              <MultiSelectDropdown
                label="Select an Employee Classifications"
                options={excludedEmployeeClassifications}
                onSelect={(value) =>
                  setFieldValue(
                    `autoEnrollment.${fields.excludedEmployeeClassifications}`,
                    value
                  )
                }
                name={`autoEnrollment.${fields.excludedEmployeeClassifications}`}
                value={get(
                  values.autoEnrollment,
                  fields.excludedEmployeeClassifications
                )}
                disabled={isEdit && !isSave}
              />
            }
            // validate={required}
            component={FieldDropSide}
          />

          {/* <Field
            size="md"
            label="Excluded Employment Status"
            options={excludedEmploymentStatuses}
            name={`autoEnrollment.${fields.excludedEmploymentStatuses}`}
            value={toMultiSelectValueById(
              selectedexcludedEmploymentStatuses,
              excludedEmploymentStatuses
            )}
            disabled={isEdit && !isSave}
            isMultiSelect
            popupContent={
              <MultiSelectDropdown
                label="Select as Employment Status"
                options={excludedEmploymentStatuses}
                onSelect={(value) =>
                  setFieldValue(
                    `autoEnrollment.${fields.excludedEmploymentStatuses}`,
                    value
                  )
                }
                // selectedOptions={fields.excludedEmploymentStatuses}
                name={`autoEnrollment.${fields.excludedEmploymentStatuses}`}
                value={get(
                  values.autoEnrollment,
                  fields.excludedEmploymentStatuses
                )}
                disabled={isEdit && !isSave}
              />
            }
            // validate={required}
            component={FieldDropSide}
          /> */}
        </>
      ) : null}

      {get(values.autoEnrollment, fields.exclusionType) === 1 ? (
        <>
          <Field
            label="Date of hire"
            name={`autoEnrollment.${fields.dateOfHire}`}
            options={toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.DATE_OF_HIRE)}
            value={get(values.autoEnrollment, fields.dateOfHire)}
            selectedValue={get(values.autoEnrollment, fields.dateOfHire)}
            component={FieldButtonGroup}
            onChange={(value) => {
              onDateOfHireChange(value);
              setFieldValue(`autoEnrollment.${fields.dateOfHire}`, value);
            }}
            disabled={isEdit && !isSave}
            size="smd"
            isRequired
          />
          {get(values.autoEnrollment, fields.dateOfHire) === 1 ? (
            <Field
              label="Hired on or after date"
              name={`autoEnrollment.${fields.hiredOnOrAfterDateEnrollment}`}
              isDatePicker
              isRequired
              // {...rest}
              value={usDateFormat(
                get(values.autoEnrollment, fields.hiredOnOrAfterDateEnrollment)
              )}
              selectedValue={get(
                values.autoEnrollment,
                fields.hiredOnOrAfterDateEnrollment
              )}
              component={FieldDropSide}
              onClear={() =>
                setFieldValue(
                  `autoEnrollment.${fields.hiredOnOrAfterDateEnrollment}`,
                  null
                )
              }
              disabled={isEdit && !isSave}
              popupContent={
                <DatePicker
                  onDayClick={(value) =>
                    onDaySelected(
                      `autoEnrollment.${fields.hiredOnOrAfterDateEnrollment}`,
                      value
                    )
                  }
                  value={usDateFormat(
                    get(
                      values.autoEnrollment,
                      fields.hiredOnOrAfterDateEnrollment
                    )
                  )}
                />
              }
            />
          ) : null}

          {get(values.autoEnrollment, fields.dateOfHire) === 2 ? (
            <Field
              label="Hired on or before date"
              name={`autoEnrollment.${fields.hiredOnOrBeforeDateEnrollment}`}
              isDatePicker
              // {...rest}
              value={usDateFormat(
                get(values.autoEnrollment, fields.hiredOnOrBeforeDateEnrollment)
              )}
              selectedValue={get(
                values.autoEnrollment,
                fields.hiredOnOrBeforeDateEnrollment
              )}
              component={FieldDropSide}
              onClear={() =>
                setFieldValue(
                  `autoEnrollment.${fields.hiredOnOrBeforeDateEnrollment}`,
                  null
                )
              }
              disabled={isEdit && !isSave}
              isRequired
              popupContent={
                <DatePicker
                  onDayClick={(value) =>
                    onDaySelected(
                      `autoEnrollment.${fields.hiredOnOrBeforeDateEnrollment}`,
                      value
                    )
                  }
                  value={usDateFormat(
                    get(
                      values.autoEnrollment,
                      fields.hiredOnOrBeforeDateEnrollment
                    )
                  )}
                />
              }
            />
          ) : null}

          {get(values.autoEnrollment, fields.dateOfHire) === 3 ? (
            <>
              <p className="font-weight-500 text-black">
                Hired Between(Inclusive)
              </p>
              <Row>
                <Col md="4">
                  <Field
                    label="From"
                    name={`autoEnrollment.${fields.hiredBetweenFrom}`}
                    isDatePicker
                    size="md"
                    isRequired
                    // {...rest}
                    value={usDateFormat(
                      get(values.autoEnrollment, fields.hiredBetweenFrom)
                    )}
                    selectedValue={get(
                      values.autoEnrollment,
                      fields.hiredBetweenFrom
                    )}
                    component={FieldDropSide}
                    onClear={() =>
                      setFieldValue(
                        `autoEnrollment.${fields.hiredBetweenFrom}`,
                        null
                      )
                    }
                    disabled={isEdit && !isSave}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(
                            `autoEnrollment.${fields.hiredBetweenFrom}`,
                            value
                          )
                        }
                        value={usDateFormat(
                          get(values.autoEnrollment, fields.hiredBetweenFrom)
                        )}
                      />
                    }
                  />
                </Col>
                <Col>
                  <Field
                    label="To"
                    name={`autoEnrollment.${fields.hiredBetweenTo}`}
                    isDatePicker
                    size="md"
                    isRequired
                    // {...rest}
                    value={usDateFormat(
                      get(values.autoEnrollment, fields.hiredBetweenTo)
                    )}
                    selectedValue={get(
                      values.autoEnrollment,
                      fields.hiredBetweenTo
                    )}
                    component={FieldDropSide}
                    onClear={() =>
                      setFieldValue(
                        `autoEnrollment.${fields.hiredBetweenTo}`,
                        null
                      )
                    }
                    disabled={isEdit && !isSave}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(
                            `autoEnrollment.${fields.hiredBetweenTo}`,
                            value
                          )
                        }
                        value={usDateFormat(
                          get(values.autoEnrollment, fields.hiredBetweenTo)
                        )}
                      />
                    }
                  />
                </Col>
              </Row>
            </>
          ) : null}

          {/* <Field
            size="md"
            label="Excluded Employment Status"
            options={excludedEmploymentStatuses}
            name={`autoEnrollment.${fields.excludedEmploymentStatuses}`}
            value={toMultiSelectValueById(
              selectedexcludedEmploymentStatuses,
              excludedEmploymentStatuses
            )}
            disabled={isEdit && !isSave}
            isMultiSelect
            popupContent={
              <MultiSelectDropdown
                label="Select as Employment Status"
                options={excludedEmploymentStatuses}
                onSelect={(value) =>
                  setFieldValue(
                    `autoEnrollment.${fields.excludedEmploymentStatuses}`,
                    value
                  )
                }
                selectedOptions={fields.excludedEmploymentStatuses}
                name={`autoEnrollment.${fields.excludedEmploymentStatuses}`}
                value={get(
                  values.autoEnrollment,
                  fields.excludedEmploymentStatuses
                )}
                disabled={isEdit && !isSave}
              />
            }
            // validate={required}
            component={FieldDropSide}
          /> */}
        </>
      ) : null}

      {get(values.autoEnrollment, fields.exclusionType) === 3 ? (
        <>
          <Field
            size="md"
            isRequired
            label="Excluded Employee Classifications"
            options={excludedEmployeeClassifications}
            name={`autoEnrollment.${fields.excludedEmployeeClassifications}`}
            value={toMultiSelectValueById(
              selectedExcludedEmployeeClassifications,
              excludedEmployeeClassifications
            )}
            disabled={isEdit && !isSave}
            isMultiSelect
            popupContent={
              <MultiSelectDropdown
                label="Select an Employee Classifications"
                options={excludedEmployeeClassifications}
                onSelect={(value) =>
                  setFieldValue(
                    `autoEnrollment.${fields.excludedEmployeeClassifications}`,
                    value
                  )
                }
                name={`autoEnrollment.${fields.excludedEmployeeClassifications}`}
                value={get(
                  values.autoEnrollment,
                  fields.excludedEmployeeClassifications
                )}
                disabled={isEdit && !isSave}
              />
            }
            // validate={required}
            component={FieldDropSide}
          />

          <Field
            label="Date of hire"
            name={`autoEnrollment.${fields.dateOfHire}`}
            options={toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.DATE_OF_HIRE)}
            value={get(values.autoEnrollment, fields.dateOfHire)}
            selectedValue={get(values.autoEnrollment, fields.dateOfHire)}
            component={FieldButtonGroup}
            onChange={(value) => {
              onDateOfHireChange(value);
              setFieldValue(`autoEnrollment.${fields.dateOfHire}`, value);
            }}
            disabled={isEdit && !isSave}
            size="smd"
            isRequired
          />

          {get(values.autoEnrollment, fields.dateOfHire) === 1 ? (
            <Field
              label="Hired on or after date"
              name={`autoEnrollment.${fields.hiredOnOrAfterDateEnrollment}`}
              isDatePicker
              {...rest}
              value={usDateFormat(
                get(values.autoEnrollment, fields.hiredOnOrAfterDateEnrollment)
              )}
              selectedValue={get(
                values.autoEnrollment,
                fields.hiredOnOrAfterDateEnrollment
              )}
              component={FieldDropSide}
              onClear={() =>
                setFieldValue(
                  `autoEnrollment.${fields.hiredOnOrAfterDateEnrollment}`,
                  null
                )
              }
              disabled={isEdit && !isSave}
              isRequired
              popupContent={
                <DatePicker
                  onDayClick={(value) =>
                    onDaySelected(
                      `autoEnrollment.${fields.hiredOnOrAfterDateEnrollment}`,
                      value
                    )
                  }
                  value={usDateFormat(
                    get(
                      values.autoEnrollment,
                      fields.hiredOnOrAfterDateEnrollment
                    )
                  )}
                />
              }
            />
          ) : (
            <div></div>
          )}

          {get(values.autoEnrollment, fields.dateOfHire) === 2 ? (
            <Field
              label="Hired on or before date"
              isRequired
              name={`autoEnrollment.${fields.hiredOnOrBeforeDateEnrollment}`}
              isDatePicker
              {...rest}
              value={usDateFormat(
                get(values.autoEnrollment, fields.hiredOnOrBeforeDateEnrollment)
              )}
              selectedValue={get(
                values.autoEnrollment,
                fields.hiredOnOrBeforeDateEnrollment
              )}
              component={FieldDropSide}
              onClear={() =>
                setFieldValue(
                  `autoEnrollment.${fields.hiredOnOrBeforeDateEnrollment}`,
                  null
                )
              }
              disabled={isEdit && !isSave}
              popupContent={
                <DatePicker
                  onDayClick={(value) =>
                    onDaySelected(
                      `autoEnrollment.${fields.hiredOnOrBeforeDateEnrollment}`,
                      value
                    )
                  }
                  value={usDateFormat(
                    get(
                      values.autoEnrollment,
                      fields.hiredOnOrBeforeDateEnrollment
                    )
                  )}
                />
              }
            />
          ) : (
            <div></div>
          )}

          {get(values.autoEnrollment, fields.dateOfHire) === 3 ? (
            <>
              <p className="font-weight-500 text-black">
                Hired Between(Inclusive)
              </p>
              <Row>
                <Col md="4">
                  <Field
                    label="From"
                    name={`autoEnrollment.${fields.hiredBetweenFrom}`}
                    isDatePicker
                    isRequired
                    size="md"
                    // {...rest}
                    value={usDateFormat(
                      get(values.autoEnrollment, fields.hiredBetweenFrom)
                    )}
                    selectedValue={get(
                      values.autoEnrollment,
                      fields.hiredBetweenFrom
                    )}
                    component={FieldDropSide}
                    onClear={() =>
                      setFieldValue(
                        `autoEnrollment.${fields.hiredBetweenFrom}`,
                        null
                      )
                    }
                    disabled={isEdit && !isSave}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(
                            `autoEnrollment.${fields.hiredBetweenFrom}`,
                            value
                          )
                        }
                        value={usDateFormat(
                          get(values.autoEnrollment, fields.hiredBetweenFrom)
                        )}
                      />
                    }
                  />
                </Col>
                <Col>
                  <Field
                    label="To"
                    name={`autoEnrollment.${fields.hiredBetweenTo}`}
                    isDatePicker
                    isRequired
                    size="md"
                    // {...rest}
                    value={usDateFormat(
                      get(values.autoEnrollment, fields.hiredBetweenTo)
                    )}
                    selectedValue={get(
                      values.autoEnrollment,
                      fields.hiredBetweenTo
                    )}
                    component={FieldDropSide}
                    onClear={() =>
                      setFieldValue(
                        `autoEnrollment.${fields.hiredBetweenTo}`,
                        null
                      )
                    }
                    disabled={isEdit && !isSave}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(
                            `autoEnrollment.${fields.hiredBetweenTo}`,
                            value
                          )
                        }
                        value={usDateFormat(
                          get(values.autoEnrollment, fields.hiredBetweenTo)
                        )}
                      />
                    }
                  />
                </Col>
              </Row>
            </>
          ) : null}
        </>
      ) : null}
      <Field
        size="md"
        label="Excluded Employment Status"
        options={excludedEmploymentStatuses}
        name={`autoEnrollment.${fields.excludedEmploymentStatuses}`}
        value={toMultiSelectValueById(
          selectedexcludedEmploymentStatuses,
          excludedEmploymentStatuses
        )}
        disabled={isEdit && !isSave}
        isMultiSelect
        popupContent={
          <MultiSelectDropdown
            label="Select as Employment Status"
            options={excludedEmploymentStatuses}
            onSelect={(value) =>
              setFieldValue(
                `autoEnrollment.${fields.excludedEmploymentStatuses}`,
                value
              )
            }
            // selectedOptions={fields.excludedEmploymentStatuses}
            name={`autoEnrollment.${fields.excludedEmploymentStatuses}`}
            value={get(
              values.autoEnrollment,
              fields.excludedEmploymentStatuses
            )}
            disabled={isEdit && !isSave}
          />
        }
        // validate={required}
        component={FieldDropSide}
      />
    </div>
  );
};

export default ExcludedEmployeeClassficationFields;
